$(document).ready(function () {

  // Checkout Button -----------------------------------------------
  
  $("button.checkout").on("click", function () {
    // console.log("Checkout button clicked");
    return true;
  });

  // Header Menu Toggle --------------------------------------------

  $(".menu-toggle").on("click", function () {
    $("body").toggleClass("menu-toggled");
    $("body").removeClass("menu-collapsed");

    if ($(".mobile-overlay-menu").css('opacity') == "0") {
      $(this).text("Close");
    } else {
      $(this).text("Menu");
    }
  });

  // Overlay menu toggle --------------------------------------------

  $(window).resize(function () {
    $("body").removeClass("menu-toggled");
    $(".menu-toggle").text("Menu");
  });

  $(".mobile-overlay-menu li a").click(function () {
    $("body").removeClass("menu-toggled");
    $(".menu-toggle").text("Menu");
  });

  // Nav menu scroll functions --------------------------------------------

  var position = $(window).scrollTop(); 

$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if(scroll > position) {
      $("body").not(".index").addClass("menu-collapsed");

      if ($(".mobile-overlay-menu").css('opacity') == "1") {
        $(".menu-toggle").text("Close");
      } else {
        $(".menu-toggle").text("Menu");
      }
    } else {
  $("body").not(".index").removeClass("menu-collapsed");
}
    position = scroll;
});

  // $(window).bind("mousewheel", function (event) {
  //   if (event.originalEvent.wheelDelta >= 50) {
  //     // console.log("Scroll up");
  //     $("body").not(".index").removeClass("menu-collapsed");
  //   }
  //   if (event.originalEvent.wheelDelta <= -50) {
  //     // console.log("Scroll down");
  //     $("body").not(".index").addClass("menu-collapsed");

  //     if ($(".mobile-overlay-menu").css('opacity') == "1") {
  //       $(".menu-toggle").text("Close");
  //     } else {
  //       $(".menu-toggle").text("Menu");
  //     }
  //   }
  // });

  // Collections Archive Bio Open / Close --------------------------------------------

  $(".collection-bio-toggle-open").click(function () {
    // console.log("Open toggle clicked");

    if ($(this).next().is(":hidden")) {
      // $(this).text("Back");
      $(this).next().css("display", "block");
      $(document.body).addClass("no-scroll");
    } else {
      // $(this).text("Collection Bio");
      // $(this).css({ top: "1rem", right: "2rem" });
      // $(this).next().css("display", "none");
    }
  });

  $(".collection-bio-toggle-close").click(function () {
    // console.log("Close toggle clicked");

    if ($(".collection-bio-wrapper").is(":visible")) {
      // $(this).text("Back");
      $(".collection-bio-wrapper").css("display", "none");
      $(document.body).removeClass("no-scroll");
    } else {
    }
  });


  // Footer subscription toggle --------------------------------------------

  $(".footer-subscribe-toggle").on("click", function () {
    // console.log("Toggle subscribe forms");

    $(".subscribe-popup").toggleClass("visible");
  });

  // Footer sound toggle --------------------------------------------

  $(".footer-sound-toggle").text("Sound On");
  $(".footer-sound-toggle").on("click", function () {

    // var slide = document.querySelectorAll('.swiper-slide');
    // const slides = document.querySelectorAll('.swiper-slide');

    const activeSlide = document.querySelector(".swiper-slide-active");
    const activeVideo = activeSlide.querySelector("iframe");
    const activePlayer = new Vimeo.Player(activeVideo);

    if ($(".footer-sound-toggle").text() == "Sound On") {
      $(".footer-sound-toggle").text("Sound Off");
      console.log("Unmuted – sound on!");
    
      // To unmute active video
      activePlayer.setMuted(false).then(function (muted) {
      }).catch(function (error) {
      });

    } else {
      $(".footer-sound-toggle").text("Sound On");

      // To mute active videos
      activePlayer.setMuted(true).then(function (muted) {
      }).catch(function (error) {
      });
        
    }
  });

  swiper.on('slideChange', function () {
    var x = document.querySelectorAll("iframe");
    var nodelist = x.length;
  
    for (i = 0; i < nodelist; i++) {

      var player = new Vimeo.Player(x[i]);
  
      player.setMuted(true).then(function() {  
        $(".footer-sound-toggle").text("Sound On");          
      }).catch(function(error) {    		
      });

    }
  });

  



  // Shop page collection title margin --------------------------------------------

  if ($(".expanded").is(":visible")) {
    //   $(".page-collection-list .container-fluid.collection-title:first .row").css(
    //     {
    //       paddingTop: "300px",
    //     }
    //   );
    // } else {
    //   $(".page-collection-list .container-fluid.collection-title:first .row").css(
    //     {
    //       paddingTop: "160px",
    //     }
    //   );
  }
});
